import cn from 'classnames'

import { FunctionComponentType } from '@interfaces/commons/FunctionComponent'
import { TableProps, TableRowProps } from './interface'

export function Table({ children, className, onScroll }: TableProps) {
  return (
    <div className={cn('overflow-y-auto', className)} onScroll={onScroll}>
      {children}
    </div>
  )
}

Table.Header = function ({ children, className }: FunctionComponentType) {
  return (
    <div className={cn('text-xs text-secondary-1 font-bold', className)}>
      {children}
    </div>
  )
}

Table.Row = function ({ children, className, onClick }: TableRowProps) {
  return (
    <div
      className={cn(
        'grid grid-cols-[19%_19%_12%_20%_25%_5%] mobile:grid-cols-[150px_150px_150px_150px_250px_50px]',
        {
          'cursor-pointer hover:bg-blue-2 dark:hover:bg-dark': !!onClick,
        },
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

Table.Column = function ({ children, className }: FunctionComponentType) {
  return (
    <div
      className={cn(
        'text-[14px] text-secondary dark:text-white-2 font-light',
        className
      )}
    >
      {children}
    </div>
  )
}
